import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import { useRef } from "react";
import { useClickAway } from "react-use";
import { positionStyles, textStyles } from "ui";

type Props = ComponentProps["Generic"]["Menu"]["Root"];

export function Root({ children, onOpenChange }: Props) {
  const ref = useRef(null);
  useClickAway(ref, () => {
    onOpenChange && onOpenChange(false);
  });
  return (
    <div ref={ref} className={classNames(positionStyles.relative, textStyles.neutral600)}>
      {children}
    </div>
  );
}
